module.exports = __webpack_public_path__ + "img/f.1.7c126ad0.png";